import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { Form } from 'semantic-ui-react';

import { ItemColorFieldEnum } from 'Common/FieldEnum';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { ColorSetupTypeEnum, CategoryEnum } from '../helpers/constants';
import { SERVED_ITEMS_COLOR_SETUP_FORM_NAME } from 'Common/FormEnum';
import { SemanticUiColorPickerWrapper } from 'Common/ReduxFormFields';
import ReactTable from 'Common/ReactTableWrapper';

class ColorSetupTable extends Component {
  static propTypes = {
    colorSetupType: PropTypes.number.isRequired,
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    loading: false,
  };

  state = { elDate: null };

  render() {
    const { loading, data, colorSetupType } = this.props;

    return (
      <Form>
        <ReactTable
          saveState={{ tableName: TableNamesEnum.COLOR_SETUP_TABLE }}
          loading={loading}
          data={data}
          columns={this.getColumns(colorSetupType)}
        />
      </Form>
    );
  }

  getColumns = colorSetupType => {
    return [
      {
        Header: 'Id',
        accessor: ItemColorFieldEnum.Id,
        show: false,
      },
      ...(colorSetupType === ColorSetupTypeEnum.NutritionCode
        ? [
            {
              Header: 'Code',
              accessor: ItemColorFieldEnum.Code,
              filterable: true,
              minWidth: 50,
              maxWidth: 50,
            },
          ]
        : []),
      {
        Header: 'Description',
        accessor: ItemColorFieldEnum.Description,
        filterable: true,
        minWidth: 300,
        maxWidth: 300,
      },
      {
        Header: 'Color',
        filterable: false,
        accessor: ItemColorFieldEnum.Color,
        minWidth: 100,
        Cell: ({ row, index }) => (
          <Field
            name={`${index}.Color`}
            component={SemanticUiColorPickerWrapper}
            disabled={
              colorSetupType === ColorSetupTypeEnum.Category &&
              row[ItemColorFieldEnum.Id] === CategoryEnum.Planned
            }
          />
        ),
      },
    ];
  };
}

const validate = () => {};

export const ColorSetupTableForm = reduxForm({
  form: SERVED_ITEMS_COLOR_SETUP_FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(withRouter(ColorSetupTable));



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/components/ColorSetupTableForm.js